import { string } from 'yup';
import { RegisterFormValidationModel } from '@/src/lib/validation/models/register-form-validation.model';
import { ValidationConfigAT } from '@/src/lib/validation/validation.config';
import { getMaxLengthMessage, getZipCodeMessage } from '@/src/lib/dictionary/utils';

export class RegisterFormValidationModelAT extends RegisterFormValidationModel {
  public get zipCode() {
    const fieldName = this.DICT.userProfile.userData.postcode;

    return string()
      .required(this.REQUIRED_MESSAGE)
      .matches(ValidationConfigAT.ZIP_REGEX, getZipCodeMessage(this.DICT, this.TENANT_CONFIG.zipCodeExample.default))
      .length(
        ValidationConfigAT.ZIP_MAX_LENGTH,
        getMaxLengthMessage(fieldName, ValidationConfigAT.ZIP_MAX_LENGTH, this.DICT),
      )
      .trim();
  }
}
